<mc-filter-picker cdkTrapFocus [color]="color" [filterable]="filterable" [columnInputs]="columnInputs"></mc-filter-picker>